import { render } from "./ExcelenciaOperacionalView.vue?vue&type=template&id=0697e5a8"
import script from "./ExcelenciaOperacionalView.vue?vue&type=script&lang=js"
export * from "./ExcelenciaOperacionalView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__